import React, { useState, useEffect } from 'react';
import { Spinner, Alert } from 'react-bootstrap';
import axios from 'axios';

const CheckoutForm = ({ plan, onSubscriptionSuccess }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const generateLinkAndRedirect = async () => {
      setIsProcessing(true);
      setError('');

      try {
        // 1. Pede a URL de pagamento para o backend
        const response = await axios.post('/api/subscriptions/create-payment-link', {
          plan_id: plan.id,
        });

        const paymentUrl = response.data.url;

        if (paymentUrl) {
          // 2. Redireciona o usuário para a página de checkout da Pagar.me
          window.location.href = paymentUrl;
        } else {
          throw new Error('URL de pagamento não recebida.');
        }
      } catch (err) {
        const apiError = err.response?.data?.message || err.message || 'Ocorreu um erro.';
        console.error("Erro ao gerar link de pagamento:", err.response?.data || err);
        setError(`Falha ao iniciar o pagamento: ${apiError}`);
        setIsProcessing(false); // Para o spinner para que o erro seja visível
      }
    };

    generateLinkAndRedirect();
  }, [plan.id, onSubscriptionSuccess]); // Dependências do efeito

  return (
    <div className="d-flex flex-column align-items-center justify-content-center p-4">
      {isProcessing && <Spinner animation="border" />}
      {error ? (
        <Alert variant="danger" className="mt-3">{error}</Alert>
      ) : (
        <p className="mt-3 text-muted">Redirecionando para o checkout seguro...</p>
      )}
    </div>
  );
};

export default CheckoutForm;
